<a #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="appMenu" (click)="$event.stopPropagation(); onContextualMenuClick($event, index); menuTrigger.openMenu()">
    <mat-icon matTooltip="Afficher le menu" class="option-icon">more_vert</mat-icon>
</a>
<mat-menu #appMenu="matMenu" class="avmup-menu">
    @if (folderConsultationRight) {
        <a class="avmup-menu-item mat-mdc-menu-item" (click)="displayFolder()">
            <mat-icon matTooltip="Visualiser les details">visibility</mat-icon>
            <span>Visualiser les détails</span>
        </a>
    }
    @if (toggleReadStateRight && isArchiveView === false) {
        @if (row.isRead) {
            <a
                (click)="toggleReadState(false)"
                [ngClass]="row.lockedType === lockedType.LockedByOtherUser ? 'avmup-menu-item mat-mdc-menu-item menu-item-disable' : 'avmup-menu-item mat-mdc-menu-item'">
                <mat-icon matTooltip="Marqué non lu">email</mat-icon>
                <span>Marquer comme non lu</span>
            </a>
        } @else {
            <a
                (click)="toggleReadState(true)"
                [ngClass]="row.lockedType === lockedType.LockedByOtherUser ? 'avmup-menu-item mat-mdc-menu-item menu-item-disable' : 'avmup-menu-item mat-mdc-menu-item'">
                <mat-icon matTooltip="Marqué lu">drafts</mat-icon>
                <span>Marquer comme lu</span>
            </a>
        }
    }
    @if (moveFolderToBoxRight && row.boxId && isArchiveView === false) {
        <a
            (click)="moveToBox()"
            [ngClass]="row.lockedType === lockedType.LockedByOtherUser ? 'avmup-menu-item mat-mdc-menu-item menu-item-disable' : 'avmup-menu-item mat-mdc-menu-item'">
            <mat-icon matTooltip="Changer de bannette">move_to_inbox</mat-icon>
            <span>Changer de bannette</span>
        </a>
    }
    @if (mergeFoldersRight && isArchiveView === false && isFollowedFolders === false) {
        <a
            (click)="mergeFile()"
            [ngClass]="row.lockedType === lockedType.LockedByOtherUser ? 'avmup-menu-item mat-mdc-menu-item menu-item-disable' : 'avmup-menu-item mat-mdc-menu-item'">
            <mat-icon matTooltip="Fusionner">merge</mat-icon>
            <span>Fusionner</span>
        </a>
    }
    @if (duplicateFoldersRight && isArchiveView === false) {
        <a class="avmup-menu-item mat-mdc-menu-item" (click)="duplicateFolder()">
            <mat-icon matTooltip="Dupliquer">folder_copy</mat-icon>
            <span>Dupliquer</span>
        </a>
    }
    @if (addFileToFolderRight && isArchiveView === false) {
        <a
            (click)="addFile()"
            [ngClass]="row.lockedType === lockedType.LockedByOtherUser ? 'avmup-menu-item mat-mdc-menu-item menu-item-disable' : 'avmup-menu-item mat-mdc-menu-item'">
            <mat-icon matTooltip="Attacher un fichier">attach_file</mat-icon>
            <span>Attacher un fichier</span>
        </a>
    }
    @if (standByRight && isArchiveView === false) {
        @if (row.isInStandByState) {
            <a
                (click)="changeStandByState(false)"
                [ngClass]="row.lockedType === lockedType.LockedByOtherUser ? 'avmup-menu-item mat-mdc-menu-item menu-item-disable' : 'avmup-menu-item mat-mdc-menu-item'">
                <mat-icon matTooltip="Sortir le dossier de veille">hourglass_disabled</mat-icon>
                <span>Sortir le dossier de veille</span>
            </a>
        } @else {
            <a
                (click)="changeStandByState(true)"
                [ngClass]="row.lockedType === lockedType.LockedByOtherUser ? 'avmup-menu-item mat-mdc-menu-item menu-item-disable' : 'avmup-menu-item mat-mdc-menu-item'">
                <mat-icon matTooltip="Mettre le dossier en veille">hourglass_empty</mat-icon>
                <span>Mettre le dossier en veille</span>
            </a>
        }
    }
    @if (folderConsultationRight && isArchiveView === false) {
        <a class="avmup-menu-item mat-mdc-menu-item" (click)="copyTrackingLink()">
            <mat-icon matTooltip="Copier le lien de suivi">link</mat-icon>
            <span>Copier le lien de suivi</span>
        </a>
    }
    @if (unlockFolderRight && isArchiveView === false) {
        <a class="avmup-menu-item mat-mdc-menu-item" (click)="unlockFolder()">
            <mat-icon matTooltip="Déverrouiller le dossier">lock_open</mat-icon>
            <span>Déverrouiller le dossier</span>
        </a>
    }
    @if (archiveRight && isArchiveView === false) {
        <a
            (click)="archive()"
            [ngClass]="row.lockedType === lockedType.LockedByOtherUser ? 'avmup-menu-item mat-mdc-menu-item menu-item-disable' : 'avmup-menu-item mat-mdc-menu-item'">
            <mat-icon matTooltip="Archiver">inventory_2</mat-icon>
            <span>Archiver</span>
        </a>
    }

    @if (archiveRight && isArchiveView === false) {
        @if (row.isInWaitingArchivingState === true) {
            <a
                (click)="removeFromWaitingArchivingState()"
                [ngClass]="row.lockedType === lockedType.LockedByOtherUser ? 'avmup-menu-item mat-mdc-menu-item menu-item-disable' : 'avmup-menu-item mat-mdc-menu-item'">
                <mat-icon matTooltip="Retirer le dossier de l'état en attente d'archivage">unarchive</mat-icon>
                <span>Retirer le dossier de l'état en attente d'archivage</span>
            </a>
        } @else {
            <a
                (click)="setInWaitingArchivingState()"
                [ngClass]="row.lockedType === lockedType.LockedByOtherUser ? 'avmup-menu-item mat-mdc-menu-item menu-item-disable' : 'avmup-menu-item mat-mdc-menu-item'">
                <mat-icon matTooltip="Placer le dossier en attente d'archivage">archive</mat-icon>
                <span>Placer le dossier en attente d'archivage</span>
            </a>
        }
    }
    @if (folderDeletionRight && isArchiveView === false) {
        <a
            (click)="deleteFolder()"
            [ngClass]="row.lockedType === lockedType.LockedByOtherUser ? 'avmup-menu-item mat-mdc-menu-item menu-item-disable' : 'avmup-menu-item mat-mdc-menu-item'">
            <mat-icon matTooltip="Supprimer">delete</mat-icon>
            <span>Supprimer</span>
        </a>
    }
    @if (followFolderRight && isArchiveView === false) {
        @if (row.isFollowed) {
            <a class="avmup-menu-item mat-mdc-menu-item" (click)="followFolder(false)">
                <mat-icon matTooltip="Arrêter de suivre le dossier">star_outline</mat-icon>
                <span>Arrêter de suivre le dossier</span>
            </a>
        } @else {
            <a class="avmup-menu-item mat-mdc-menu-item" (click)="followFolder(true)">
                <mat-icon matTooltip="Suivre le dossier">star</mat-icon>
                <span>Suivre le dossier</span>
            </a>
        }
    }
</mat-menu>
